<template>
  <div id="app" >
    <router-view v-if="isRouterAlive" ></router-view>
    <!-- <div class="homeover" v-if="show" @click="closed()">
      <div style="margin-left:28vw">
        <div style="height:27.83vh"></div>
        <img src="@/assets/image/tshi.png" class="tishimiddleImg" />
        <p class="tishiFontSize" style="margin-left:20px">请横屏观看</p>
        <div style="height:10vh"></div>
        <a
          ><div class="tishibtn" style="margin-left:10px" @click="closed()">
            知道了
          </div></a
        >
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      show: false
    };
  },
  created() {},
  mounted() {
    var that = this;
    var evt = "onorientationchange" in window ? "orientationchange" : "resize";
    window.addEventListener(evt, resize, false);
    function resize(fals) {
      if (window.orientation == 0 || window.orientation == 180) {
        console.log("竖屏");
        that.show = true;
      } else {
        console.log("横屏");
        that.show = false;
      }
    }
    resize(true);
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    rotate() {
      if (window.orientation == 180 || window.orientation == 0) {
        console.log("竖屏");
        this.show = true;
      }
      if (window.orientation == 90 || window.orientation == -90) {
        console.log("横屏");
        this.show = false;
      }
    },
    closed() {
      this.show = false;
    }
  }
};
</script>

<style>
.htmlbody { transform: rotate(180deg); }
/* @media screen and (orientation: portrait){
　body{background:#f00}
}

@media screen and (orientation: landscape){
　body{background:#000}
} */
#app {
  font-family: "Microsoft YaHei";
  background: white;
}
p {
  margin: 0px;
}
.tishimiddleImg {
  width: 168px;
  height: 168px;
}
.homeover {
  position: fixed;
  width: 100vw;
  height: 100vh;
  opacity: 0.7;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.tishiFontSize {
  height: 32px;
  font-size: 26px;
  font-family: "PingFang SC";
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin: 0px;
}
.tishibtn {
  width: 155px;
  height: 54px;
  background: rgba(191, 191, 191, 0.1);
  border-radius: 8px;
  border: 1px solid #b6b6b6;
  font-size: 20px;
  font-family: "PingFang SC";
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 54px;
  cursor: pointer;
}
/* 左边渐入 */
@keyframes bounceInRight {
  0% {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
/* 顶部渐入 */
@keyframes bounceInTop {
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
/* 底部渐入 */
@keyframes bounceInBottom {
  0% {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: none;
  }
}

 .publicPadding16{
   padding: 16px; 
 }
 .publicRed{
   background-color: red;
   
 }
 .publicRow{
   display: flex;
   flex-direction:row;
   flex-wrap:wrap;
 }
  .publicColumn{
   display: flex;
   flex-direction:column;
 }
 .publicBetween{
   justify-content: space-between;
 }
 .publicAround{
   justify-content: space-around;
 }
 .publicCenter{
   justify-content: center;
 } 
</style> 


// WEBPACK FOOTER //
// src/App.vue